import { render, staticRenderFns } from "./selectTemplateColor.vue?vue&type=template&id=d2b4d688&"
import script from "./selectTemplateColor.vue?vue&type=script&lang=ts&"
export * from "./selectTemplateColor.vue?vue&type=script&lang=ts&"
import style0 from "./selectTemplateColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports